import { createFileRoute } from '@tanstack/react-router'

import { LABELS } from '@/constants/common/message.constants'

export const Route = createFileRoute(
  '/_protected/$tenantKey/settings/_system-master-settings/_users/dc-users'
)({
  meta: () => [{ title: LABELS.DC_USER }]
})
